module.exports = __webpack_public_path__ + "img/imagesec-2new.3a07e645.png";